<form class="select-serial-number">
    <div class="tc-form-field size-md" *ngIf="!paymentInfo.isThirdParty">
        <label class="label">
            {{'REQUEST.WITHDRAWAL.DEPOSIT_TO_MY_ACCOUNT' | translate }}
        </label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field">
            <input matInput [value]="paymentInfo.userServiceAccount" placeholder="" readonly>
        </mat-form-field>
    </div>
    <div class="tc-form-field size-md" *ngIf="paymentInfo.isThirdParty">
        <label class="label">
            {{'REQUEST.WITHDRAWAL.DEPOSIT_TO_THIRD_PARTY_ACCOUNT' | translate }}
        </label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field">
            <input matInput [value]="paymentInfo.userServiceAccount" placeholder="" readonly>
        </mat-form-field>
    </div>
</form>